import { createContext } from 'react';

const scoreContext = createContext(null);

export default scoreContext;
